import { irr } from './excel.js';
import { MONTHS_PER_YEAR } from './series.js';
/**
 * Indicateurs de tête du classeur.
 *
 * Chacun renvoie `null` là où le classeur affiche `n.a` (`IFERROR(..., "n.a")`) :
 * essentiellement une division par zéro, par exemple le taux de couverture d'un bien
 * sans dette.
 */
function divide(numerator, denominator) {
    return denominator === 0 ? null : numerator / denominator;
}
/** `F2` — TRI sur la ligne de cash-flow, de t = 0 à la fin de la frise. */
export function internalRateOfReturn(cashFlows) {
    return irr(cashFlows);
}
/** `F4` — rendement brut : loyer annuel encaissé / coût total du projet. */
export function grossYield(monthlyRent, vacancyMonths, totalProjectCost) {
    return divide(monthlyRent * (MONTHS_PER_YEAR - vacancyMonths), totalProjectCost);
}
/**
 * `F5` — rendement net : loyer moins charges (dont gestion), sur une année encaissée.
 * La somme suit l'ordre des lignes du classeur, `SUM(F37:F45)`.
 */
export function netYield(monthlyNetIncome, vacancyMonths, totalProjectCost) {
    return divide(monthlyNetIncome * (MONTHS_PER_YEAR - vacancyMonths), totalProjectCost);
}
/** `L3` — retour sur investissement, en années : apport / cash-flow de la première année. */
export function paybackYears(equity, firstYearCashFlow) {
    return divide(equity, firstYearCashFlow);
}
/** `L4` — taux de couverture : loyer mensuel / mensualité. `null` sans dette. */
export function coverageRatio(monthlyRent, monthlyPayment) {
    return divide(monthlyRent, monthlyPayment);
}
//# sourceMappingURL=kpi.js.map